import Swiper, { Autoplay, Navigation } from 'swiper';

class CampaignSlideshow extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.el = this.querySelector('[data-cs-swiper]');
    if (!this.el) return;

    this.bars = [...this.querySelectorAll('[data-cs-bar]')];
    this.autoplayOn = this.dataset.autoplay === 'true';
    this.delay = Number(this.dataset.autoplayDelay) || 5000;
    this.pcGap = Number(this.dataset.pcGap) || 130;
    this.originalCount = this.fillSlidesForLoop();
    if (this.originalCount < 2) return;

    this.addEventListener('click', (event) => {
      const slide = event.target.closest('.swiper-slide');
      if (slide && !slide.classList.contains('swiper-slide-active')) {
        event.preventDefault();
      }
    });

    const options = {
      modules: this.autoplayOn ? [Autoplay, Navigation] : [Navigation],
      loop: true,
      loopAdditionalSlides: 3,
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 0,
      speed: 500,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      slideToClickedSlide: true,
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        prevEl: this.querySelector('[data-cs-prev]'),
        nextEl: this.querySelector('[data-cs-next]'),
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: this.pcGap,
        },
      },
      on: {
        slideChange: (swiper) => {
          this.setActiveBar(this.getActiveIndex(swiper));
        },
      },
    };

    if (this.autoplayOn) {
      options.autoplay = {
        delay: this.delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
      options.on.autoplayTimeLeft = (_swiper, _time, progress) => {
        this.setFill(1 - progress);
      };
    }

    this.swiper = new Swiper(this.el, options);

    this.bars.forEach((bar) => {
      bar.addEventListener('click', () => {
        const index = Number(bar.dataset.csIndex);
        if (Number.isNaN(index)) return;
        this.swiper.slideToLoop(index);
      });
    });

    this.setActiveBar(this.getActiveIndex(this.swiper));
  }

  fillSlidesForLoop() {
    const wrapper = this.el.querySelector('.swiper-wrapper');
    if (!wrapper) return 0;

    const originals = [...wrapper.querySelectorAll('.swiper-slide')];
    const count = originals.length;
    if (count < 2) return count;

    const minSlides = Math.max(8, count * 2);
    let i = 0;
    while (wrapper.querySelectorAll('.swiper-slide').length < minSlides) {
      const clone = originals[i % count].cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.remove('swiper-slide-active');
      wrapper.appendChild(clone);
      i += 1;
    }
    return count;
  }

  getActiveIndex(swiper) {
    const slide = swiper?.slides?.[swiper.activeIndex];
    const index = Number(slide?.getAttribute('data-cs-index'));
    if (!Number.isNaN(index)) return index;
    return (swiper?.realIndex || 0) % this.originalCount;
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
  }

  setActiveBar(index) {
    this.bars.forEach((bar, i) => {
      const on = i === index;
      bar.classList.toggle('is-active', on);
      const fill = bar.querySelector('[data-cs-bar-fill]');
      if (!fill) return;
      if (!on) {
        fill.style.transform = 'scaleX(0)';
      } else if (!this.autoplayOn) {
        fill.style.transform = 'scaleX(1)';
      }
    });
  }

  setFill(ratio) {
    const fill = this.querySelector('.campaign-slideshow__bar.is-active [data-cs-bar-fill]');
    if (!fill) return;
    const value = Math.min(1, Math.max(0, ratio));
    fill.style.transform = `scaleX(${value})`;
  }
}

if (!customElements.get('campaign-slideshow')) {
  customElements.define('campaign-slideshow', CampaignSlideshow);
}
